import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

import Container from 'components/Container';
import Stack from 'components/Stack';
import Text from 'components/Text';
import RichText from 'components/RichText';
import { PostShape } from 'utils/props';

import PostTags from './PostTags';

import { color, media } from 'styles/utils';

const StyledSection = styled.section`
  background-color: ${color('bgBlueGray')};
  padding: 10rem 1.5rem 4.5rem 1.5rem;
`;

const StyledContainer = styled(Container)`
  display: grid;
  column-gap: 2rem;
  grid-template-columns: 1fr minmax(45rem, 1fr) 1fr;
  ${media.max('lg')} {
    grid-template-columns: 1fr;
  }
`;

const StyledWing = styled.aside`
  ${media.max('lg')} {
    display: none;
  }
`;

const StickyContainer = styled.div`
  position: sticky;
  top: calc(var(--sleuth-safe-area-inset-top, 0) + 2rem);
`;

const StyledHost = styled(Stack)`
  border-radius: 0.5rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  overflow: hidden;
  background-color: ${color('white')};
`;

const StyledHostDetails = styled(Stack)`
  padding: 1rem;
`;

const MobileOnly = styled.div`
  margin: 2rem 0;
  ${media.min('lg')} {
    display: none;
  }
`;

export default function UpcomingEpisodeBody({ post }) {
  return (
    <StyledSection>
      <StyledContainer size="lg">
        <StyledWing>
          <StickyContainer>
            <StyledHost>
              <StaticImage
                alt=""
                placeholder="blurred"
                src="../../images/team/founders/don-colorful.webp"
              />
              <StyledHostDetails gap="1rem">
                <Text color="teal" variant="smallestP">
                  SLEUTH TV HOST
                </Text>
                <div>
                  <Text variant="f4" color="darkTeal">
                    Don Brown
                  </Text>
                  <Text variant="smallP" color="textTeal">
                    CTO & Co-Founder
                  </Text>
                </div>
                <Text variant="smallP" color="textTeal">
                  Don lives and breathes software as a developer, architect, and
                  manager. He's built many things still in use today, including
                  the tech behind Atlassian Marketplace.
                </Text>
              </StyledHostDetails>
            </StyledHost>
          </StickyContainer>
        </StyledWing>

        <div>
          <RichText value={post.body} />
        </div>

        <StyledWing>
          <StickyContainer>
            <Stack gap="2rem">
              <PostTags post={post} />
            </Stack>
          </StickyContainer>
        </StyledWing>
      </StyledContainer>

      <MobileOnly>
        <PostTags post={post} />
      </MobileOnly>
    </StyledSection>
  );
}

UpcomingEpisodeBody.propTypes = {
  post: PostShape,
};
